var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inner" },
    [
      _c("nav", { staticClass: "breadcrumb is-small has-dot-separator" }, [
        _c("ul", [
          _c(
            "li",
            [_c("b-icon", { attrs: { icon: "home", size: "is-small" } })],
            1
          ),
          _vm.portefeuille
            ? _c("li", { staticClass: "is-active" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.portefeuille.name) +
                      "\n        "
                  )
                ])
              ])
            : _vm._e(),
          _vm.site
            ? _c("li", { staticClass: "is-active" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _vm._v("\n          " + _vm._s(_vm.site.name) + "\n        ")
                ])
              ])
            : _vm._e(),
          _vm.bien
            ? _c("li", { staticClass: "is-active" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _vm._v("\n          " + _vm._s(_vm.bien.name) + "\n        ")
                ])
              ])
            : _vm._e(),
          _c("li", { staticClass: "is-active" }, [
            _c("a", { attrs: { href: "#" } }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.activeTab === 0
                      ? _vm.$t("p-bien.title-doc")
                      : _vm.$t("p-bien.title-question")
                  ) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm.activeTab === 0 && (_vm.$route.query.invdoc || _vm.$route.query.dl)
        ? _c("PortefeuilleDocumentApercu")
        : _vm._e(),
      _c(
        "b-tabs",
        {
          attrs: { animated: false },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "b-tab-item",
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c("b-icon", { attrs: { icon: "folder", size: "is-small" } }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("p-bien.title-doc")) +
                      "\n      "
                  )
                ],
                1
              ),
              _c("PortefeuilleDocuments")
            ],
            2
          ),
          _c(
            "b-tab-item",
            { attrs: { visible: _vm.allowQuestions && _vm.cgaOk } },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c("b-icon", {
                    attrs: { icon: "question-circle", size: "is-small" }
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("p-bien.title-question")) +
                      "\n      "
                  )
                ],
                1
              ),
              _c("PortefeuilleQuestions")
            ],
            2
          ),
          _c(
            "b-tab-item",
            { attrs: { visible: _vm.cgaOk } },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c("b-icon", {
                    attrs: { icon: "envelope", size: "is-small", pack: "far" }
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("p-bien.title-notif")) +
                      "\n      "
                  )
                ],
                1
              ),
              _c("PortefeuilleNotifications")
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }